import { Box, Flex, Image, useBreakpointValue } from "@chakra-ui/react";
import teamBg from "@/assets/images/team_banner.png";
import teamImg from "@/assets/images/teamimg.png";

const MyTeam = () => {
  const fontSize1 = useBreakpointValue({
    base: '14px', 
    md: '18px', 
    lg: '22px',  
  });
  
  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          我的团队
        </Box>
        <Flex
          h="149px"
          position={"relative"}
          bg={`url('${teamBg}')`}
          backgroundSize="cover"
          backgroundPosition="top center"
          bgRepeat={"no-repeat"}
          alignItems="center"
        >
          <Box w="60%" p="20px" color={"#27314D"} fontSize={fontSize1}>我的团队是为设计师们和企业提供团队协作服务的板块，支持多人同时在线协同，助力设计团队提高效率和质量，目前还在不断完善中，敬请期待。</Box>
        </Flex>
        <Box mt="40px" color={"#27314D"} fontSize="18px" fontWeight={"bold"}>
          部分效果预展示
        </Box>
        <Flex mt="35px" mb="60px" justifyContent={"center"}>
          <Image src={teamImg} />
        </Flex>
      </Box>
    </Box>
  );
};

export default MyTeam;
